import { ErrorHandler, Injectable } from '@angular/core';
import {Logger} from '../../classes/util/logger';
import {ApiErrorService} from '../sp-api/sp-api-error/api-error.service';
import {environment} from '../../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class LoggerService {
  constructor(private apiError: ApiErrorService,
              private errorHandler: ErrorHandler) { }

  debug(...message: any) {
    Logger.logDebug(...message);
  }

  logInfo(message: any, priority: number = 1) { 
    Logger.logInfo(message, priority);
  }

  logWarning(message: any, priority: number = 1) {
    Logger.logWarning(message, priority);
  }

  /**
   * Logging of error
   * Set priority to 3 or more to send an error report (only working for production environment)
   * @param message
   * @param severity
   * @param error
   */
  logError(message: any, severity: number = 1, error?: Error) {
    if (error) console.error(error);

    Logger.logError(message, severity);

    if (severity >= 2 && error) this.errorHandler.handleError(error);
    
    if (severity >= 3) {
      this.debug("Log error severity of " + severity + " => sending error report");
      this.apiError.sendErrorReport(message, error);
    }
  }
}
